import React from "react";
import { Typography } from "antd";

// Illustration "couverture santé" affichée sous le menu latéral
const SideIllustration = () => {
  const logoBlue = "#114b88";
  const logoBlueLight = "#1f5fa8";
  const logoOrange = "#f1ce57";

  return (
    <div
      style={{
        margin: "24px 16px 16px",
        padding: "18px 12px 16px",
        borderRadius: 18,
        background: `linear-gradient(180deg, ${logoBlue}0d 0%, ${logoOrange}1f 100%)`,
        border: `1px solid ${logoBlue}14`,
        textAlign: "center",
        overflow: "hidden",
      }}
    >
      <style>{`
        @keyframes ipm-float { 0%,100% { transform: translateY(0) } 50% { transform: translateY(-5px) } }
        @keyframes ipm-pulse { 0%,100% { transform: scale(1) } 50% { transform: scale(1.08) } }
        .ipm-float { animation: ipm-float 4s ease-in-out infinite; }
        .ipm-float-slow { animation: ipm-float 5.5s ease-in-out infinite; }
        .ipm-pulse { transform-box: fill-box; transform-origin: center; animation: ipm-pulse 1.8s ease-in-out infinite; }
      `}</style>

      <svg viewBox="0 0 220 190" width="100%" style={{ maxWidth: 210, display: "block", margin: "0 auto" }}>
        <defs>
          <linearGradient id="ipm-shield" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={logoBlueLight} />
            <stop offset="100%" stopColor={logoBlue} />
          </linearGradient>
          <linearGradient id="ipm-heart" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#f8dc7a" />
            <stop offset="100%" stopColor="#e9b93a" />
          </linearGradient>
        </defs>

        {/* Halo de fond */}
        <circle cx="110" cy="88" r="74" fill={`${logoBlue}0f`} />
        <circle cx="110" cy="88" r="56" fill={`${logoOrange}2e`} />

        {/* Croix et points flottants */}
        <g className="ipm-float-slow" fill={logoOrange}>
          <path d="M28 40h6v-6h4v6h6v4h-6v6h-4v-6h-6z" />
          <circle cx="190" cy="52" r="4" />
          <circle cx="36" cy="120" r="3" fill={`${logoBlue}55`} />
        </g>
        <g className="ipm-float" fill={`${logoBlue}66`}>
          <path d="M178 104h5v-5h3v5h5v3h-5v5h-3v-5h-5z" />
          <circle cx="58" cy="22" r="3" />
        </g>

        {/* Bouclier avec croix médicale */}
        <g className="ipm-float">
          <path
            d="M110 22 L152 38 V78 C152 108 133 128 110 138 C87 128 68 108 68 78 V38 Z"
            fill="url(#ipm-shield)"
            style={{ filter: `drop-shadow(0 8px 14px ${logoBlue}40)` }}
          />
          <path
            d="M110 32 L143 45 V78 C143 102 128 118 110 127 C92 118 77 102 77 78 V45 Z"
            fill="none"
            stroke="#ffffff"
            strokeOpacity="0.25"
            strokeWidth="2"
          />
          <rect x="102" y="56" width="16" height="44" rx="4" fill="#ffffff" />
          <rect x="88" y="70" width="44" height="16" rx="4" fill="#ffffff" />

          {/* Cœur */}
          <path
            className="ipm-pulse"
            d="M150 96 c-5-6-15-3-15 5 c0 7 9 12 15 17 c6-5 15-10 15-17 c0-8-10-11-15-5z"
            fill="url(#ipm-heart)"
            stroke="#ffffff"
            strokeWidth="2.5"
          />
        </g>

        {/* Famille */}
        <g>
          {/* Adulte gauche */}
          <circle cx="62" cy="128" r="9" fill={logoBlueLight} />
          <path d="M46 172 c0-16 7-26 16-26 s16 10 16 26z" fill={logoBlueLight} />
          {/* Adulte droit */}
          <circle cx="158" cy="128" r="9" fill={logoBlue} />
          <path d="M142 172 c0-16 7-26 16-26 s16 10 16 26z" fill={logoBlue} />
          {/* Enfant */}
          <circle cx="110" cy="146" r="7.5" fill={logoOrange} />
          <path d="M97 172 c0-12 6-19 13-19 s13 7 13 19z" fill={logoOrange} />
        </g>

        {/* Sol */}
        <rect x="30" y="172" width="160" height="4" rx="2" fill={`${logoBlue}1f`} />
      </svg>

      <Typography.Text
        style={{ display: "block", marginTop: 10, fontWeight: 700, fontSize: 14, color: logoBlue }}
      >
        Votre santé, notre priorité
      </Typography.Text>
      <Typography.Text style={{ display: "block", fontSize: 12, color: "#64748b", lineHeight: 1.4 }}>
        Une couverture médicale pour vous et toute votre famille
      </Typography.Text>
    </div>
  );
};

export default SideIllustration;
